import {
  REFERENTIAl_STATES_ENDPOINTS,
  useReferentialStates,
} from "@/entities/referential/referential-states";

export const useRecommendedInterventionsBarData = (observation) => {
  const { states: referentialStates } = useReferentialStates(
    REFERENTIAl_STATES_ENDPOINTS.INTERVENTION
  );

  const {
    // Fallback to 0 to make sure we display ui even if
    // recommended_intervention is not defined
    done = 0,
    progress = 0,
    total = 0,
    states = {},
  } = observation?.recommended_interventions ?? {};

  const barData = Object.entries(states).reduce((data, [stateValue, nbr]) => {
    const state = referentialStates.find((s) => s.value === stateValue);
    const stateTitle = state?.name ?? stateValue;

    return {
      ...data,
      [state]: {
        nbr,
        color: state?.color,
        key: stateTitle,
        width: `${(nbr / total) * 100}%`,
        tooltip: `${stateTitle} : ${nbr}`,
      },
    };
  }, {});

  return {
    done,
    progress,
    total,
    barData,
  };
};
